<template>
  <div class="reportDetailsBlockHeader">Processing History</div>
  <div class="modalBlock" ref="detailsContainer">
    <div v-for="(item, index) in history" :key="index" class="accordionItem">
      <!-- Accordion Header -->
      <div class="itemLine" @click="toggle(index)">
        <div class="name" :style="isOpen(index) && 'font-weight: bold'">Record #{{ index + 1 }}</div>
        <div class="value">
          <span>
            <BIconChevronRight v-if="!isOpen(index)" />
            <BIconChevronDown v-else />
          </span>
        </div>
      </div>

      <!-- Accordion Body -->
      <div v-if="isOpen(index)" class="accordionBody">
        <div class="itemLine">
          <div class="name itemName">Status</div>
          <div class="value">{{ splitCamelCase(item.status) }}</div>
        </div>
        <div class="itemLine">
          <div class="name itemName">Processed By</div>
          <div class="value">{{ item.by === 'ai' ? item.by.toUpperCase() : splitCamelCase(item.by) }}</div>
        </div>
        <div class="itemLine">
          <div class="name itemName">Processing Reason</div>
          <div class="value">{{ item.reason }}</div>
        </div>
        <div class="itemLine">
          <div class="name itemName">Processed at</div>
          <div class="value">{{ format(new Date(item.timestamp * 1000), 'yyyy-MM-dd HH:mm:ss') }}</div>
        </div>
        <div v-if="item.ai_explanation" class="itemLine">
          <div class="name itemName">AI report</div>
          <div class="value">{{ item.ai_explanation }}</div>
        </div>
        <div v-if="item.ai_cost" class="itemLine">
          <div class="name itemName">AI cost</div>
          <div class="value">${{ item.ai_cost }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import { useHelper } from '@/use/helper'
import { BIconChevronDown, BIconChevronRight } from 'bootstrap-icons-vue'

export default {
  components: { BIconChevronDown, BIconChevronRight },
  props: {
    history: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      openIndexes: [],
      format
    }
  },
  setup() {
    const { splitCamelCase } = useHelper()

    return { splitCamelCase }
  },
  methods: {
    toggle(index) {
      if (this.openIndexes.includes(index)) {
        this.openIndexes = this.openIndexes.filter((i) => i !== index)
      } else {
        this.openIndexes.push(index)
      }
    },
    isOpen(index) {
      return this.openIndexes.includes(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.accordionItem {
  border-bottom: 1px solid #ddd;
  &:last-child {
    border-bottom: none;
  }
}
.itemLine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.accordionBody {
  padding-left: 8px;
  padding-right: 8px;
  white-space: pre-wrap;
  word-break: break-word;
  .value {
    text-align: right;
  }
}
.itemName {
  width: 100px;
  min-width: 100px;
}
</style>
